import { render, staticRenderFns } from "./p-f-u-edit-audience-popup.vue?vue&type=template&id=3c915b6c&scoped=true"
import script from "./p-f-u-edit-audience-popup.vue?vue&type=script&lang=js"
export * from "./p-f-u-edit-audience-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c915b6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c915b6c')) {
      api.createRecord('3c915b6c', component.options)
    } else {
      api.reload('3c915b6c', component.options)
    }
    module.hot.accept("./p-f-u-edit-audience-popup.vue?vue&type=template&id=3c915b6c&scoped=true", function () {
      api.rerender('3c915b6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mprofiles/views/find-user/popups/p-f-u-edit-audience-popup.vue"
export default component.exports